import React from 'react'
import CloseIcon from 'components/material-symbol/icons/Close'
import {
  useChannelPreviewInfo,
  useChannelStateContext,
  useTranslationContext,
} from 'stream-chat-react'

const MessagingThreadHeader = ({
  closeThread,
  overrideImage,
  overrideTitle,
}) => {
  const { t } = useTranslationContext('ThreadHeader')
  const { channel } = useChannelStateContext('ThreadHeader')
  const { displayTitle } = useChannelPreviewInfo({
    channel,
    overrideImage,
    overrideTitle,
  })

  return (
    <div className="str-chat__thread-header">
      <div className="str-chat__thread-header-details">
        <div className="str-chat__thread-header-title">{t('Thread')}</div>
        <div className="str-chat__thread-header-subtitle">{displayTitle}</div>
      </div>
      <button
        aria-label={t('aria/Close thread')}
        className="str-chat__close-thread-button"
        data-testid="close-button"
        onClick={closeThread}
        type="button"
      >
        <CloseIcon fontSize={24} htmlColor="rgba(0, 0, 0, 0.6)" />
      </button>
    </div>
  )
}

export default MessagingThreadHeader
